import OutlierDetectorEditDto from './OutlierDetectorEditDto';
import RuleBasedOutlierDetectorRuleEditDto from './RuleBasedOutlierDetectorRuleEditDto';

export class RuleBasedModelEditDto extends OutlierDetectorEditDto {
	constructor() {
		super();
		/** @type {number} */
		this.measurement = null;
		/** @type {RuleBasedOutlierDetectorRuleEditDto[]} */
		this.rules = null;
	}

	/**
	 * @typedef {Object} _RuleBasedModelEditDtoProps
	 * @property {number} measurement
	 * @property {RuleBasedOutlierDetectorRuleEditDto[]} rules
	 *
	 * @typedef {import("./OutlierDetectorEditDto").OutlierDetectorEditDtoProps & _RuleBasedModelEditDtoProps} RuleBasedModelEditDtoProps
	 */
	/**
	 *
	 * @param {RuleBasedModelEditDtoProps} props
	 * @returns {RuleBasedModelEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.measurement = props.measurement;
		this.rules = Array.isArray(props.rules)
			? props.rules.map((rule) => new RuleBasedOutlierDetectorRuleEditDto().setup(rule))
			: [];
			
		return this;
	}
}

export default RuleBasedModelEditDto;